import * as React from "react";

/**
 * Lets a component written in the React 19 style (reading `ref` straight off its props) receive its ref on React 18 too.
 *
 * React 18 strips `ref` from the props of plain function components, so `props.ref` is always undefined there.
 * Wrapping in `forwardRef` hands the ref over as a second argument, which is merged back into props before calling
 * the component. On React 19 this is a no-op in behaviour. Can be removed once no consumer is on React 18.
 *
 * The component is called as a plain function, so its hooks run as part of the `forwardRef` render. This is safe
 * because the wrapped component never changes for a given wrapper.
 */
export const withRefProp = <C extends (props: any) => React.ReactNode>(Component: C): C & { displayName?: string } => {
  const Wrapped = React.forwardRef<unknown, any>((props, ref) => Component({ ...props, ref }));
  Wrapped.displayName = (Component as { displayName?: string }).displayName || Component.name;
  return Wrapped as unknown as C & { displayName?: string };
};
